export const PASSWORD_POLICY_MESSAGE =
  "Password must be at least 6 characters and include a letter, a number, and a special symbol.";

export const isStrongPassword = (value) =>
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/.test(String(value || ""));

